import {Pipe, PipeTransform} from '@angular/core';
import {SelectItem} from 'primeng/api';

@Pipe({
	name: 'optionVide'
})
export class OptionVidePipeMock implements PipeTransform {

	transform(items: SelectItem[], avecOptionVide: boolean): SelectItem[] {
		return items;
	}
}
